import React from 'react';
import { SimpleDialog, Typography, styled } from '@nextiva/next-ui-components';

const StyledSimpleDialog = styled(SimpleDialog)`
  z-index: 1400;
`;
const StyledDialogText = styled(Typography)`
  width: 349px;
  margin-bottom: 24px;
  color: ${({ theme }) => theme.palette.blueGrey.A600};
`;

const BILLING_URL = 'apps/billing/#/landing/payment';

interface IExpiredPaymentModal {
  setExpiredPaymentDialogOpen: (expiredPaymentDialogOpen: boolean) => void;
}

const onPaymentButtonClick = (): void => {
  (window as Window).location = `${window.location.origin}/${BILLING_URL}`;
};

export const ExpiredPaymentModal = ({
  setExpiredPaymentDialogOpen,
}: IExpiredPaymentModal) => (
  <StyledSimpleDialog
    data-testid="PlatformAdminUI-PurchaseLicenseModal-ExpiredPaymentModal"
    cancelButtonProps={{
      onClick: () => setExpiredPaymentDialogOpen(false),
    }}
    cancelText="Cancel"
    confirmButtonProps={{
      color: 'primary',
      onClick: onPaymentButtonClick,
    }}
    confirmText="Yes, take me to payment"
    title="Payment?"
    open
  >
    <StyledDialogText variant="body2">
      You are about to abandon the purchasing of licenses and go to the billing
      section for payment.
    </StyledDialogText>
    <StyledDialogText variant="body2">
      Are you sure you want to take this action?
    </StyledDialogText>
  </StyledSimpleDialog>
);
